/**
 * PM-4 — Create Project page (`/projects/create`).
 *
 * Now a THIN wrapper over the unified `ProjectWizard` (PMGT FE-2). The page
 * chrome (breadcrumb + heading) lives here; the whole stepper flow — Basics →
 * Parties → Parks & turbines → Review — and the FE-1 mint-on-submit hierarchy
 * live in `wizard/ProjectWizard` (`mode="create"` → `CreateModeWizard`). The
 * behaviour is identical to the shipped create flow; the create tests drive
 * this same component with the same mocked hook surface.
 *
 * The matching EDIT flow mounts the SAME `ProjectWizard` in `mode="edit"` on
 * the project detail page (`ProjectDetailPage`).
 */
import { type ReactElement } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { PageHeading } from "@aeriosiq/ui";
import { ProjectWizard } from "./wizard/ProjectWizard.js";

export function CreateProjectPage(): ReactElement {
  return (
    <Box
      sx={{
        maxWidth: 1200,
        mx: "auto",
        p: 3,
        pb: 6,
        overflowY: "auto",
        // `overflowY:auto` promotes overflow-x to auto (CSS) → latent X-scrollbar;
        // clip X so the page scrolls vertically only (matches EditModeWizard, FB-29).
        overflowX: "clip",
      }}
    >
      <Breadcrumbs sx={{ mb: 1 }}>
        <Link component={RouterLink} to="/projects" underline="hover">
          Projects
        </Link>
        <Typography color="text.primary">Create project</Typography>
      </Breadcrumbs>

      <PageHeading>Create project</PageHeading>

      <ProjectWizard mode="create" />
    </Box>
  );
}
